import React from 'react';
import { colors, Text } from '../../../globalStyles';
import { GetOrganizedSaiSurveysForOrgQuery } from '../../../graphQL';

type SurveyType =
  GetOrganizedSaiSurveysForOrgQuery['getOrganizedSaiSurveysForOrg']['activeAndUpcoming'][number];

interface SurveyPeriodDisplayProps {
  surveyPeriod: SurveyType;
}

export const SurveyPeriodDisplay = ({ surveyPeriod }: SurveyPeriodDisplayProps): JSX.Element => {
  if (!surveyPeriod) return <></>;

  return (
    <div className="p3" style={{ backgroundColor: colors.white, borderRadius: 4 }}>
      <Text.bodyBold>{surveyPeriod.name}</Text.bodyBold>
      <div className="mt2">
        <Text.bodySmall>
          <strong>Survey Display Name:</strong> {surveyPeriod.name}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Start Date:</strong> {surveyPeriod.startDate}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>End Date:</strong> {surveyPeriod.endDate}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Term:</strong> {surveyPeriod.term}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Version:</strong> {surveyPeriod.assessmentKey}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Academic Year:</strong>{' '}
          {`${surveyPeriod.academicYearStart}-${surveyPeriod.academicYearEnd}`}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Calendar Year:</strong> {surveyPeriod.calendarYear}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Target Cohort Name:</strong> {surveyPeriod.targetCohortName}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Number of Students in Eligible Cohort:</strong>{' '}
          {surveyPeriod.numberOfStudentsInCohort}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Goal Response Rate:</strong> {surveyPeriod.goalResponseRate}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Custom Content Screen:</strong>{' '}
          {surveyPeriod.customContentEnabled ? 'Enabled' : 'Disabled'}
        </Text.bodySmall>
        {surveyPeriod.customContentEnabled && surveyPeriod.customContentTitle && (
          <>
            <Text.bodySmall>
              <strong>Custom Content Title:</strong> {surveyPeriod.customContentTitle}
            </Text.bodySmall>
            {surveyPeriod.customContentDescription && (
              <Text.bodySmall>
                <strong>Custom Content Description:</strong> {surveyPeriod.customContentDescription}
              </Text.bodySmall>
            )}
          </>
        )}
      </div>
    </div>
  );
};
